module.exports = __webpack_public_path__ + "img/744.1a375868.jpg";